module.exports = __webpack_public_path__ + "img/assignment-active.c8f2dcc6.svg";